import React from 'react';

import './Navbar.css';

function Navbar() {
  return (
    <div className="container">
      <ul className="container">
        <li><h2>VChat</h2></li>
        <li><b><a href="https://vchat-4u.netlify.app/">Back to HomePage</a></b>
        </li>
      </ul>
    </div>
  );
}

export default Navbar;
